







































export default function (Component) {
  Component.options.__source = "src/module/components/lolth-explorer/renderer/cmp-rgb-color-cell-renderer.vue"
}
